import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/about.css';
import aboutBg from '../../images/about-bg.jpg';
import about1 from '../../images/about1.jpg';

const About = () => {
  const values = [
    {
      icon: 'fa-star',
      title: 'Our Mission',
      description: 'To provide innovative technology solutions and top-tier IT talent that empower businesses to thrive in the digital age.'
    },
    {
      icon: 'fa-eye',
      title: 'Our Vision',
      description: 'To be the leading partner for organizations seeking transformative software services and IT staffing solutions.'
    },
    {
      icon: 'fa-handshake-o',
      title: 'Our Values',
      description: 'Excellence, Innovation, Integrity, and Client Success guide everything we do.'
    }
  ];

  const stats = [
    { value: '50+', label: 'Clients Served' },
    { value: '100+', label: 'Projects Delivered' },
    { value: '40+', label: 'Expert Team Members' },
    { value: '99%', label: 'Client Satisfaction' }
  ];

  return (
    <>
      {/* Hero Banner */}
        <section 
            className="about-hero"
            style={{
                background: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${aboutBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}
            >
            <div className="about-hero-content">
                <h1 style={{ color: '#00e7ff' }} className="animated-title">VinfoCloud</h1>
                <f className="hero-tagline animated-tagline">
                    <span className="acronym-v">Visionary</span> • 
                    <span className="acronym-i">Innovative</span> • 
                    <span className="acronym-n">Next-Gen</span> • 
                    <span className="acronym-f">Future-Ready</span> • 
                    <span className="acronym-o">Optimized</span>
                </f>
                <p className="hero-subtitle animated-subtitle">
                    Transforming businesses through cloud-powered technology solutions 
                    and expert IT talent acquisition.
                </p>
                <Link to="/contact" className="btn about-page-btn-primary">Connect With Us</Link>
            </div>
        </section>

      {/* About Content */}
      <section className="section about-content-section">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <h2 style={{ color: '#00e7ff' }} className="section-title">Who We Are</h2>
              <p className="about-description">
                VinfoCloud is a premier software services and IT staffing company 
                based in Houston, Texas. We specialize in delivering innovative 
                technology solutions and providing access to top-tier IT talent.
              </p>
              <p className="about-description">
                Founded with the mission to bridge the gap between businesses and 
                technology, we help organizations of all sizes leverage cutting-edge 
                software solutions and build robust IT teams.
              </p>
              <div className="about-features">
                <div className="about-feature">
                  <i className="fa fa-check"></i>
                  <span>Expert software development services</span>
                </div>
                <div className="about-feature">
                  <i className="fa fa-check"></i>
                  <span>Comprehensive IT staffing solutions</span>
                </div>
                <div className="about-feature">
                  <i className="fa fa-check"></i>
                  <span>Cloud and AI implementation</span>
                </div>
                <div className="about-feature">
                  <i className="fa fa-check"></i>
                  <span>Dedicated project management</span>
                </div>
              </div>
            </div>
            <div className="about-image">
              <div className="image-container">
                <img 
                  src={about1}
                  alt="VinfoCloud Team" 
                  className="about-img"
                />
                <div className="image-overlay">
                  <span>VinfoCloud - Software & IT Staffing Experts</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="section values-section">
        <div className="container">
          <div className="section-header">
            <h2 style={{ color: '#00e7ff' }} className="section-title">Our Core Principles</h2>
            <p className="section-subtitle">The foundation of everything we do at VinfoCloud</p>
          </div>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">
                  <i className={`fa ${value.icon}`}></i>
                </div>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="section stats-section">
        <div className="container">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-card">
                <h3 className="stat-value">{stat.value}</h3>
                <p className="stat-label">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

    {/* Our Journey */}
    <section className="section journey-section">
    <div className="container">
        <div className="section-header">
        <h2 style={{ color: '#00e7ff' }} className="section-title">Our Journey</h2>
        <p className="section-subtitle">From startup to industry leader - The VinfoCloud story</p>
        </div>
        
        <div className="journey-timeline">
        <div className="journey-card">
            <div className="journey-year">2018</div>
            <div className="journey-content">
            <div className="journey-icon">
                <i className="fa fa-rocket"></i>
            </div>
            <h3 style={{ color: '#00e7ff' }} className="journey-title">Company Founded</h3>
            <p className="journey-description">
                VinfoCloud was established in Houston, Texas with a vision to bridge 
                the gap between businesses and technology solutions.
            </p>
            </div>
        </div>
        
        <div className="journey-card">
            <div className="journey-year">2019</div>
            <div className="journey-content">
            <div className="journey-icon">
                <i className="fa fa-users"></i>
            </div>
            <h3 style={{ color: '#00e7ff' }} className="journey-title">First Major Client</h3>
            <p className="journey-description">
                Secured our first enterprise client, delivering custom software solutions 
                that increased their operational efficiency by 40%.
            </p>
            </div>
        </div>
        
        <div className="journey-card">
            <div className="journey-year">2020</div>
            <div className="journey-content">
            <div className="journey-icon">
                <i className="fa fa-cloud"></i>
            </div>
            <h3 style={{ color: '#00e7ff' }} className="journey-title">Cloud Expansion</h3>
            <p className="journey-description">
                Launched our cloud services division, helping businesses migrate to AWS 
                and optimize their cloud infrastructure.
            </p>
            </div>
        </div>
        
        <div className="journey-card">
            <div className="journey-year">2022</div>
            <div className="journey-content">
            <div className="journey-icon">
                <i className="fa fa-arrow-up"></i>
            </div>
            <h3 style={{ color: '#00e7ff' }} className="journey-title">Rapid Growth</h3>
            <p className="journey-description">
                Expanded our team to 40+ experts and served 50+ clients across various 
                industries including healthcare, finance, and retail.
            </p>
            </div>
        </div>
        
        <div className="journey-card">
            <div className="journey-year">2023</div>
            <div className="journey-content">
            <div className="journey-icon">
                <i className="fa fa-cogs"></i>
            </div>
            <h3 style={{ color: '#00e7ff' }} className="journey-title">AI & ML Integration</h3>
            <p className="journey-description">
                Introduced AI and Machine Learning services, helping clients leverage 
                GenAI for business intelligence and automation.
            </p>
            </div>
        </div>
        
        <div className="journey-card">
            <div className="journey-year">2024</div>
            <div className="journey-content">
            <div className="journey-icon">
                <i className="fa fa-trophy"></i>
            </div>
            <h3 style={{ color: '#00e7ff' }} className="journey-title">Industry Recognition</h3>
            <p className="journey-description">
                Received industry awards for innovation and excellence in software 
                development and IT staffing services.
            </p>
            </div>
        </div>
        </div>
        
        <div className="journey-stats">
        <div className="journey-stat">
            <h3 className="stat-number">6+</h3>
            <p className="stat-label">Years of Excellence</p>
        </div>
        <div className="journey-stat">
            <h3 className="stat-number">100+</h3>
            <p className="stat-label">Projects Delivered</p>
        </div>
        <div className="journey-stat">
            <h3 className="stat-number">50+</h3>
            <p className="stat-label">Happy Clients</p>
        </div>
        <div className="journey-stat">
            <h3 className="stat-number">99%</h3>
            <p className="stat-label">Client Retention</p>
        </div>
        </div>
    </div>
    </section>

      {/* CTA Section */}
      <section className="section cta-section">
          <div className="cta-content">
            <h2 style={{ color: '#00e7ff' }} >Partner With VinfoCloud</h2>
            <p>
              Let's build something amazing together. Whether you need software solutions 
              or IT talent, we're here to help you succeed.
            </p>
            <div className="cta-buttons">
              <Link to="/services" className="btn btn-primary">
                Explore Our Services
              </Link>
              <Link to="/contact" className="btn btn-outline">
                Contact Us
              </Link>
            </div>
        </div>
      </section>
    </>
  );
};

export default About;